import { render, staticRenderFns } from "./AddOrEditFavorite.vue?vue&type=template&id=606480ca&scoped=true"
import script from "./AddOrEditFavorite.vue?vue&type=script&lang=js"
export * from "./AddOrEditFavorite.vue?vue&type=script&lang=js"
import style0 from "./AddOrEditFavorite.vue?vue&type=style&index=0&id=606480ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606480ca",
  null
  
)

export default component.exports